module.exports = "/images/ROM_portada.jpg?e5f3bde8ecc7fc8ea1552ad3b6076d92";